import { takeEvery, put, call } from "redux-saga/effects"

// Support Tickets Redux States
import {
    GET_TICKETS,
    GET_TICKET_DETAIL,
    CREATE_SUPPORT_TICKET,
    REPLY_SUPPORT_TICKET,
} from "./actionTypes"
import {
    getTicketsSuccess,
    getTicketsFail,
    getTicketDetailSuccess,
    getTicketDetailFail,
    createSupportTicketSuccess,
    createSupportTicketFail,
    replySupportTicketSuccess,
    replySupportTicketFail,
} from "./actions"

// Include helper Step 1
import {
    getTickets,
    getTicketDetail,
    addNewTicket,
    replySupportTicket,
} from "../../helpers/fakebackend_helper"

function* fetchTickets({ payload: params }) {
    try {
        const response = yield call(getTickets, params)
        yield put(getTicketsSuccess(response))
    } catch (error) {
        yield put(getTicketsFail(error))
    }
}

function* fetchTicketDetail({ payload: id }) {
    try {
        const response = yield call(getTicketDetail, id)
        yield put(getTicketDetailSuccess(response))
    } catch (error) {
        yield put(getTicketDetailFail(error))
    }
}

function* onCreateSupportTicket({ payload: { ticket, navigate } }) {
    try {
        const response = yield call(addNewTicket, ticket)
        yield put(createSupportTicketSuccess(response.ticket))
        if (typeof navigate === 'function') {
            navigate("/support/tickets")
        }
    } catch (error) {
        yield put(createSupportTicketFail(error))
    }
}

function* onReplyTicket({ payload: { id, message } }) {
    try {
        const response = yield call(replySupportTicket, id, message)
        yield put(replySupportTicketSuccess(response.reply))
    } catch (error) {
        yield put(replySupportTicketFail(error))
    }
}

function* ticketSaga() {
    yield takeEvery(GET_TICKETS, fetchTickets)
    yield takeEvery(GET_TICKET_DETAIL, fetchTicketDetail)
    yield takeEvery(CREATE_SUPPORT_TICKET, onCreateSupportTicket)
    yield takeEvery(REPLY_SUPPORT_TICKET, onReplyTicket)
}

export default ticketSaga
